import { createMutationHook } from '~/shared/providers/api';

export const useUpdateTransportationTypeMutation = createMutationHook(
  'transportation.transportationTypeUpdate',
  (params: { id: string; name?: string; description?: string }) => ({
    transportationTransportationTypeUpdate: {
      __args: {
        id: params.id,
        input: {
          name: params.name,
          description: params.description,
        },
      },
      id: true,
      name: true,
      description: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
